import { ScrollRevealWrapper } from '../../../components/feature/ScrollRevealWrapper';

const passos = [
  {
    num: '01',
    icon: 'ri-compass-3-line',
    title: 'Autoconhecimento',
    desc: 'Descubra seus padrões mentais, crenças limitantes e gatilhos emocionais através do diagnóstico personalizado',
  },
  {
    num: '02',
    icon: 'ri-tools-line',
    title: 'Reprogramação',
    desc: 'Aplique técnicas de PNL e neurociência para criar novos caminhos neurais e substituir padrões sabotadores',
  },
  {
    num: '03',
    icon: 'ri-calendar-check-line',
    title: 'Prática Diária',
    desc: 'Rituais matinais, diário de gratidão e exercícios gamificados que transformam conhecimento em resultado',
  },
  {
    num: '04',
    icon: 'ri-trophy-line',
    title: 'Transformação',
    desc: 'Resultados reais e mensuráveis: mais confiança, clareza mental e performance profissional em 7 dias',
  },
];

const stats = [
  { value: '98%', label: 'Completam o programa' },
  { value: '7 dias', label: 'Para primeiros resultados' },
  { value: '4.9/5', label: 'Avaliação média' },
];

function ComoFunciona() {
  return (
    <section className="py-24 bg-[#060606] relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_40%,rgba(201,164,64,0.07),transparent_60%)]"></div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-500/10 to-transparent"></div>

      <div className="container mx-auto px-4 relative z-10">
        <ScrollRevealWrapper animation="fade-up">
          <div className="text-center mb-20">
            <div className="inline-flex items-center gap-4 mb-6">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-gold-500/60"></div>
              <span className="text-gold-400 text-xs font-semibold tracking-[0.35em] uppercase font-['Montserrat']">
                Metodologia
              </span>
              <div className="h-px w-10 bg-gradient-to-l from-transparent to-gold-500/60"></div>
            </div>
            <h2 className="font-display text-5xl md:text-6xl font-bold mb-5 text-white leading-tight">
              Como Funciona a <span className="text-gold-400">Transformação</span>
            </h2>
            <p className="text-lg text-white/50 max-w-2xl mx-auto leading-relaxed font-['Montserrat'] font-light">
              Um processo estruturado e validado que guia você do autoconhecimento à transformação real
            </p>
          </div>
        </ScrollRevealWrapper>

        {/* Steps */}
        <div className="max-w-5xl mx-auto mb-20">
          <div className="grid md:grid-cols-4 gap-6 relative">
            {/* Connector line desktop */}
            <div className="hidden md:block absolute top-10 left-[12.5%] right-[12.5%] h-px bg-gradient-to-r from-gold-500/50 via-gold-400/30 to-gold-500/50"></div>

            {passos.map((passo, i) => (
              <ScrollRevealWrapper key={i} animation="fade-up" delay={0.1 * (i + 1)}>
                <div className="relative flex flex-col items-center text-center">
                  {/* Number circle */}
                  <div className="relative z-10 w-20 h-20 bg-gradient-to-br from-gold-500 to-gold-700 rounded-full flex items-center justify-center border-4 border-[#060606] mb-6 shadow-[0_0_25px_rgba(201,164,64,0.35)]">
                    <span className="font-display text-xl font-bold text-[#0a0a0a]">{passo.num}</span>
                  </div>
                  {/* Card */}
                  <div className="bg-[#111111] border border-gold-500/10 rounded-2xl p-6 hover:border-gold-500/30 transition-all duration-500 w-full">
                    <div className="w-10 h-10 flex items-center justify-center bg-gold-500/10 rounded-xl mx-auto mb-4">
                      <i className={`${passo.icon} text-xl text-gold-400`}></i>
                    </div>
                    <h3 className="text-base font-bold text-white mb-2 font-display">{passo.title}</h3>
                    <p className="text-white/45 text-xs leading-relaxed font-['Montserrat']">{passo.desc}</p>
                  </div>
                </div>
              </ScrollRevealWrapper>
            ))}
          </div>
        </div>

        {/* Stats */}
        <ScrollRevealWrapper animation="fade-up" delay={0.5}>
          <div className="grid md:grid-cols-3 gap-8 max-w-2xl mx-auto">
            {stats.map((s, i) => (
              <div key={i} className="text-center">
                <div className="font-display text-5xl font-bold text-gold-400 mb-2">{s.value}</div>
                <p className="text-white/45 font-['Montserrat'] text-sm">{s.label}</p>
              </div>
            ))}
          </div>
        </ScrollRevealWrapper>
      </div>
    </section>
  );
}

export default ComoFunciona;
